export const domains = {
    directline: {
        devSite: 'https://directline-okta-nonprod.dlgdigitalservices.com',
        prodSite: 'https://prod.okta.directline.com'
    },
    churchill: {
        devSite: 'https://okta-ch.qa.dlgdigitalservices.com',
        prodSite: 'https://prod.okta.churchill.com'
    },
    privilege: {
        devSite: 'https://privilege-okta-nonprod.dlgdigitalservices.com',
        prodSite: 'https://prod.okta.privilege.com'
    }
  };

export const authServerIds = {
    directline: {
        devSite: 'default',
        prodSite: 'default'
    },
    churchill: {
        devSite: 'default',
        prodSite: 'default'
    },
    privilege: {
        devSite: 'ausi1p4wmpo0Ppn460h7',
        prodSite: 'aus2prgewqzQQDtEB0i7'
    }
  };

export function getOktaClientId(brand, env, app) {
    let clientId;
    if (app === 'VA') {
        if (brand === 'directline') {
            clientId = (env === 'prodSite') ? '0oa5ax4emjCNl9nDk417' : '0oa4jwvqi96pBTC5M0x7';
        } else if (brand === 'churchill') {
            clientId = (env === 'prodSite') ? '0oa8tv0mulEhBAyVp0i7' : '0oa1d9jonvczRrBQm0h8';
        } else {
            clientId = (env === 'prodSite') ? '0oa8tuvta6g3XI5A40i7' : '0oa18y737bx5EeZpK0h8';
        }
    } else {
        if (brand === 'directline') {
            clientId = (env === 'prodSite') ? '0oa27924eCelaVPAe416' : '0oa8zk3lsdfGKdv480x6';
        } else if (brand === 'churchill') {
            clientId = (env === 'prodSite') ? '0oana2iny2TgfzOcR0h7' : '0oa4anulqqvP8iyNN0i7';
        } else {
            clientId = (env === 'prodSite') ? '0oa2prg8q8EkxWNY30i7' : '0oahxsd1c2JNNEwjZ0h7';
        }
    }
    return clientId;
  }
